































import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { GlobalState } from "../store/state";
import { UserError, RetryOperation } from "../lib/error";

export default Vue.extend({
  data() {
    return {
      retrying: false,
    };
  },
  computed: {
    ...mapState<GlobalState>({
      message: (state: GlobalState) =>
        state.lastError?.UserMessage ??
        state.lastError?.message ??
        "error desconocido",
      retryOp: (state: GlobalState) => (state.lastError as UserError)?.retryOp,
      errorPresent: (state: GlobalState) => !!state.lastError,
    }),
  },
  methods: {
    ...mapMutations({
      close: "CLEAR_ERROR",
    }),
    retry() {
      const retryOp: RetryOperation | undefined = (this as {
        retryOp?: RetryOperation;
      }).retryOp;
      if (!retryOp) {
        return;
      }
      this.retrying = true;
      (this.$store.dispatch(retryOp.name, retryOp.payload) as Promise<
        void
      >).finally(() => {
        this.retrying = false;
      });
    },
  },
});
